import {
  SET_VOUCHER_CODE,
  FETCHING_VOUCHER_DATA,
  SET_VOUCHER_DETAIL,
  VoucherActionTypes,
  VoucherManagementType,
  VoucherCode,
  Trial,
  AppThunk,
} from '../types';
import ApiClient from '../../loopback/apiClient';

const fetchingVoucherData = (payload: boolean): VoucherActionTypes => ({
  type: FETCHING_VOUCHER_DATA,
  payload,
});

export const setVoucherCode = (voucherData: VoucherManagementType[]): VoucherActionTypes => ({
  type: SET_VOUCHER_CODE,
  payload: voucherData,
});

/**
 * Fetch the VoucherCode data for a specific trial
 * and dispatch data to redux state
 *
 * @param trialId - id of the trial we want data for
 */
export const fetchVoucherCode = (trialId: number): AppThunk => async (
  dispatch, getState,
): Promise<void> => {
  const state = getState();
  if (state.voucher.fetchingVoucherData) {
    return;
  }
  dispatch(fetchingVoucherData(true));
  const voucherData = await ApiClient.getVoucherData(trialId);
  const voucherManagementData: VoucherManagementType[] = voucherData.map((record) => {
    const combineData: VoucherManagementType = {
      id: record.id,
      claimedOn: record.claimedOn,
      quipUserId: record.quipUserId,
      trialId: record.trialId,
      code: record.code,
      ...record.quipUser,
      enrollmentStatus: record.enrollment?.status,
    };
    return combineData;
  });
  dispatch(setVoucherCode(voucherManagementData));
  dispatch(fetchingVoucherData(false));
};

export const setVoucherDetail = (payload: VoucherCode & {trial: Trial}): VoucherActionTypes => ({
  type: SET_VOUCHER_DETAIL,
  payload,
});
